import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DynamicManifestJSONService {
  private _initialized = false;
  constructor(private readonly router: Router) {}

  initialize(): void {
    if (this._initialized) {
      return;
    }
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (
          typeof window !== 'undefined' &&
          typeof location !== 'undefined' &&
          window &&
          window.location &&
          document &&
          typeof URL !== 'undefined'
        ) {
          const url = new URL(window.location.href);
          url.searchParams.append('utm_source', 'homescreen');
          const stringManifest = JSON.stringify({
            ...defaultWebManifest,
            start_url: url.href,
          });
          const blob = new Blob([stringManifest], { type: 'application/json' });
          const manifestURL = URL.createObjectURL(blob);
          const manifestTag = document.querySelector(
            '#my-manifest-placeholder'
          );
          if (manifestTag) {
            manifestTag.setAttribute('href', manifestURL);
          }
        }
      });
    this._initialized = true;
  }
}

const defaultWebManifest = Object.freeze({
  name: 'Meeting Scheduler',
  short_name: 'Meeting Scheduler',
  theme_color: '#ffffff',
  background_color: '#d50000',
  display: 'standalone',
  scope: './',
  start_url: './',
  icons: [
    {
      src: '/assets/icons/icon-72x72.png',
      sizes: '72x72',
      type: 'image/png',
      purpose: 'maskable any',
    },
    {
      src: '/assets/icons/icon-96x96.png',
      sizes: '96x96',
      type: 'image/png',
      purpose: 'maskable any',
    },
    {
      src: '/assets/icons/icon-128x128.png',
      sizes: '128x128',
      type: 'image/png',
      purpose: 'maskable any',
    },
    {
      src: '/assets/icons/icon-144x144.png',
      sizes: '144x144',
      type: 'image/png',
      purpose: 'maskable any',
    },
    {
      src: '/assets/icons/icon-152x152.png',
      sizes: '152x152',
      type: 'image/png',
      purpose: 'maskable any',
    },
    {
      src: '/assets/icons/icon-192x192.png',
      sizes: '192x192',
      type: 'image/png',
      purpose: 'maskable any',
    },
    {
      src: '/assets/icons/icon-384x384.png',
      sizes: '384x384',
      type: 'image/png',
      purpose: 'maskable any',
    },
    {
      src: '/assets/icons/icon-512x512.png',
      sizes: '512x512',
      type: 'image/png',
      purpose: 'maskable any',
    },
  ],
});
